/* KIDDUC: gedrag van de kd-secties. Geen bibliotheken, werkt in elk thema. */
(() => {
  // Knop zonder link: naar het eerste zichtbare koopformulier scrollen.
  document.addEventListener('click', (e) => {
    const knop = e.target.closest('[data-kd-naar-koop]');
    if (!knop) return;
    const formulieren = [...document.querySelectorAll('form[action*="/cart/add"]')];
    const doel = formulieren.find((f) => f.offsetParent !== null) || formulieren[0];
    if (!doel) return;
    const top = doel.getBoundingClientRect().top + window.scrollY - 90;
    window.scrollTo({ top, behavior: 'smooth' });
  });

  // Wagen (Zaka 26-10): een bundel staat als een rij, het prullenbakje haalt alle regels van die rij weg.
  document.addEventListener('click', async (e) => {
    const knop = e.target.closest('[data-kd-weg]');
    if (!knop) return;
    e.preventDefault();
    const rij = knop.closest('li');
    rij?.querySelector('.loading-overlay')?.classList.remove('hidden');
    const lade = document.querySelector('cart-drawer');
    const root = window.Shopify?.routes?.root || '/';
    const updates = Object.fromEntries(knop.dataset.kdWeg.split(',').filter(Boolean).map((k) => [k, 0]));
    try {
      const r = await fetch(`${root}cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          updates,
          sections: lade ? lade.getSectionsToRender().map((s) => s.id) : [],
          sections_url: window.location.pathname,
        }),
      });
      const antwoord = await r.json();
      if (!r.ok) throw new Error(antwoord.description || antwoord.message);
      if (lade) {
        lade.renderContents(antwoord);
        lade.classList.toggle('is-empty', antwoord.item_count === 0);
      } else window.location.reload();
    } catch (fout) {
      console.error('KIDDUC wagen', fout);
      rij?.querySelector('.loading-overlay')?.classList.add('hidden');
    }
  });

  // Magie: met de vinger over de tekening wrijven tot de kleur verschijnt.
  const magie = (vlak) => {
    const doek = vlak.querySelector('.kd-magie__doek');
    const voor = vlak.querySelector('.kd-magie__voor');
    const na = vlak.querySelector('.kd-magie__na');
    if (!doek || !voor || !na) return;
    const ctx = doek.getContext('2d');
    const terug = Number(vlak.dataset.terug || 0) * 1000;
    let wachten, schaal = 1;

    const tekenVoor = (alpha = 1) => {
      ctx.globalCompositeOperation = 'source-over';
      ctx.globalAlpha = alpha;
      ctx.drawImage(voor, 0, 0, doek.width, doek.height);
      ctx.globalAlpha = 1;
    };
    const maat = () => {
      schaal = window.devicePixelRatio || 1;
      doek.width = Math.round(na.clientWidth * schaal);
      doek.height = Math.round(na.clientHeight * schaal);
      tekenVoor();
    };
    const wrijf = (e) => {
      const r = doek.getBoundingClientRect();
      const x = (e.clientX - r.left) * schaal;
      const y = (e.clientY - r.top) * schaal;
      const straal = 34 * schaal;
      const g = ctx.createRadialGradient(x, y, 0, x, y, straal);
      g.addColorStop(0, 'rgba(0,0,0,1)');
      g.addColorStop(0.6, 'rgba(0,0,0,.6)');
      g.addColorStop(1, 'rgba(0,0,0,0)');
      ctx.globalCompositeOperation = 'destination-out';
      ctx.fillStyle = g;
      ctx.beginPath();
      ctx.arc(x, y, straal, 0, Math.PI * 2);
      ctx.fill();
      vlak.classList.add('is-bezig');
      if (terug) {
        clearTimeout(wachten);
        wachten = setTimeout(opdrogen, terug);
      }
    };
    // Het water droogt: de tekening komt langzaam terug.
    const opdrogen = () => {
      let stap = 0;
      const tik = () => {
        tekenVoor(0.06);
        if (++stap < 40) requestAnimationFrame(tik);
        else { tekenVoor(); vlak.classList.remove('is-bezig'); }
      };
      tik();
    };

    let actief = false;
    doek.addEventListener('pointerdown', (e) => { actief = true; doek.setPointerCapture(e.pointerId); wrijf(e); });
    doek.addEventListener('pointermove', (e) => { if (actief || e.pointerType === 'mouse') wrijf(e); });
    ['pointerup', 'pointercancel', 'pointerleave'].forEach((t) => doek.addEventListener(t, () => { actief = false; }));

    const start = () => { maat(); new ResizeObserver(maat).observe(na); };
    const klaar = (img) => img.complete && img.naturalWidth > 0;
    if (klaar(voor) && klaar(na)) start();
    else {
      let n = 0;
      [voor, na].forEach((img) => {
        if (klaar(img)) n++;
        else img.addEventListener('load', () => { if (++n === 2) start(); }, { once: true });
      });
      if (n === 2) start();
    }
  };

  // Aftellen naar een echte datum (bv. 1 december, eerste deurtje).
  const aftel = (el) => {
    const doel = new Date(el.dataset.kdAftel).getTime();
    if (Number.isNaN(doel)) return;
    const vakken = {
      d: el.querySelector('[data-d]'), u: el.querySelector('[data-u]'),
      m: el.querySelector('[data-m]'), s: el.querySelector('[data-s]'),
    };
    const zet = () => {
      const rest = Math.max(0, doel - Date.now());
      if (!rest) { el.hidden = true; return false; }
      const s = Math.floor(rest / 1000);
      vakken.d.textContent = Math.floor(s / 86400);
      vakken.u.textContent = String(Math.floor(s / 3600) % 24).padStart(2, '0');
      vakken.m.textContent = String(Math.floor(s / 60) % 60).padStart(2, '0');
      vakken.s.textContent = String(s % 60).padStart(2, '0');
      return true;
    };
    if (zet()) { const i = setInterval(() => { if (!zet()) clearInterval(i); }, 1000); }
  };

  // Aankondiging met afteller onder de header (Zaka en Kadir 29-10: "gewoon announcement bar met afteller sticky onder
  // header"): UU:MM:SS tot middernacht in Londen, elke dag opnieuw. De sectie plakt bovenaan en staat altijd direct onder
  // de header: schuift de header weg (omlaag scrollen), dan schuift de balk naar boven mee; komt hij terug, dan zakt de
  // balk eronder. --kd-kop-onder = onderkant van de header op het scherm.
  const saleklok = (balk) => {
    const sectie = balk.closest('.shopify-section');
    const kop = document.querySelector('.section-header');
    if (sectie) {
      sectie.classList.add('kd-saleklok-sectie');
      const plaats = () => sectie.style.setProperty('--kd-kop-onder',
        `${kop ? Math.max(0, Math.round(kop.getBoundingClientRect().bottom)) : 0}px`);
      let tot = 0;
      const volg = () => { plaats(); if (performance.now() < tot) requestAnimationFrame(volg); };
      const beweeg = () => {   // ook tijdens de schuifanimatie van de header (een halve seconde na de laatste scroll)
        plaats();
        const bezig = performance.now() < tot;
        tot = performance.now() + 600;
        if (!bezig) requestAnimationFrame(volg);
      };
      addEventListener('scroll', beweeg, { passive: true });
      addEventListener('resize', beweeg);
      plaats();
    }
    const vakken = { u: balk.querySelector('[data-u]'), m: balk.querySelector('[data-m]'), s: balk.querySelector('[data-s]') };
    const londen = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/London', hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23',
    });
    const twee = (n) => String(n).padStart(2, '0');
    const zet = () => {
      const d = Object.fromEntries(londen.formatToParts(new Date()).map((x) => [x.type, x.value]));
      const voorbij = ((+d.hour % 24) * 3600) + (+d.minute * 60) + (+d.second);
      const rest = 86400 - voorbij;
      vakken.u.textContent = twee(Math.floor(rest / 3600) % 24);
      vakken.m.textContent = twee(Math.floor(rest / 60) % 60);
      vakken.s.textContent = twee(rest % 60);
    };
    zet();
    setInterval(zet, 1000);
  };

  // Eerste productfoto (SOP punt 3): aanbodpil en USP-tegels uit het koopblok in de foto zetten.
  const fotolabels = (labels) => {
    const foto = document.querySelector('.product__media-wrapper .product__media-item .product-media-container, .product__media-wrapper .product__media-item');
    if (!foto) return;
    if (getComputedStyle(foto).position === 'static') foto.style.position = 'relative';
    foto.appendChild(labels);
    labels.hidden = false;
  };

  // Video's als een gif (Zaka 22-10): stil, in een lus, en spelen zodra ze in beeld komen. Blokkeert de telefoon
  // automatisch afspelen (spaarstand), dan start de eerste aanraking ze alsnog.
  const gif = (v) => {
    if (v.dataset.kdGif) return;
    v.dataset.kdGif = '1';
    Object.assign(v, { muted: true, loop: true, playsInline: true, controls: false, autoplay: true });
    v.setAttribute('muted', '');
    v.setAttribute('playsinline', '');
    const speel = () => { const p = v.play(); if (p) p.catch(() => {}); };
    if ('IntersectionObserver' in window) {
      new IntersectionObserver((items) => items.forEach((i) => (i.isIntersecting ? speel() : v.pause())), { rootMargin: '200px' }).observe(v);
    } else speel();
    document.addEventListener('touchstart', speel, { once: true, passive: true });
  };

  // Reel (kd-reels, Zaka 24-10): alleen achtergrond, geen speelknop en geen schermvullend. Een klik of dubbelklik
  // op de video doet niets; geen beeld-in-beeld en geen casten.
  const reel = (v) => {
    v.disablePictureInPicture = true;
    v.setAttribute('disablepictureinpicture', '');
    v.setAttribute('disableremoteplayback', '');
    v.setAttribute('tabindex', '-1');
    ['click', 'dblclick'].forEach((e) => v.addEventListener(e, (ev) => ev.preventDefault()));
  };

  // Bundel van twee varianten (adventskalender 2D + 3D, Kadir 24-10): staat het bundelvinkje aan, dan voegt de koopknop
  // (ook die in de plakbalk) beide varianten toe als losse regels en opent de winkelwagenlade. De prijs komt van de
  // automatische korting in Admin. Een modelkaart kiezen zet de bundel weer uit.
  const bundel = (vink) => {
    if (vink.dataset.kdKlaar) return;
    vink.dataset.kdKlaar = '1';
    const ids = vink.dataset.kdBundel.split(',').filter(Boolean);
    const info = vink.closest('product-info') || document;
    info.querySelectorAll('.kd-model:not(.kd-model--bundel)').forEach((k) => k.addEventListener('click', () => { vink.checked = false; }));
    document.addEventListener('submit', async (e) => {
      const form = e.target;
      if (!vink.checked || !form.matches('form[action*="/cart/add"]') || form.closest('cart-drawer')) return;
      if (!ids.includes(String(form.querySelector('[name="id"]')?.value))) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      const knop = form.querySelector('[type="submit"]');
      knop?.setAttribute('aria-disabled', 'true');
      knop?.classList.add('loading');
      const lade = document.querySelector('cart-drawer');
      const root = window.Shopify?.routes?.root || '/';
      try {
        const r = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: ids.map((id) => ({ id: Number(id), quantity: 1 })),
            sections: lade ? lade.getSectionsToRender().map((s) => s.id) : [],
            sections_url: window.location.pathname,
          }),
        });
        const antwoord = await r.json();
        if (!r.ok) throw new Error(antwoord.description || antwoord.message);
        if (lade) { lade.classList.remove('is-empty'); lade.renderContents(antwoord); } else window.location.href = `${root}cart`;
      } catch (fout) {
        console.error('KIDDUC bundel', fout);
      } finally {
        knop?.removeAttribute('aria-disabled');
        knop?.classList.remove('loading');
      }
    }, true);
  };

  // Elk stuk een ander ontwerp (kleurboek, Kadir 25-10): in een bundel kiest de klant per boek een wereld. Standaard
  // staat elk vakje #1..#n op een ander boek, zodat een 6-pak alle zes werelden heeft. data-kd-spreid = {titel: variant-id}.
  const spreid = (merk) => {
    if (merk.dataset.kdKlaar) return;
    merk.dataset.kdKlaar = '1';
    let ids = {};
    try { ids = JSON.parse(merk.dataset.kdSpreid); } catch (e) { return; }
    const info = merk.closest('product-info') || document;
    // Het thema leest de keuze alleen via het change-event, maar springt dan ook naar de foto van die variant (en zet
    // die vooraan). Tijdens het klaarzetten staat de galerij daarom even stil, zodat de hoofdfoto blijft staan.
    // start = de wereld voor #1, de rest schuift door (fotostalen, Kadir 26-10).
    const zet = (start = '') => {
      const galerijen = [...document.querySelectorAll('media-gallery')];
      galerijen.forEach((g) => { g.setActiveMedia = () => {}; });
      try {
        info.querySelectorAll('.quantity-break__variants').forEach((groep) => {
          groep.querySelectorAll('.quantity-break__selector-item').forEach((vak, i) => {
            const sel = vak.querySelector('select');
            const opties = sel ? [...sel.options].filter((o) => !o.disabled && ids[o.value]) : [];
            if (!opties.length) return;
            const eerste = Math.max(0, opties.findIndex((o) => o.value === start));
            sel.value = opties[(eerste + i) % opties.length].value;
            vak.dataset.selectedId = ids[sel.value];
            sel.dispatchEvent(new Event('change', { bubbles: true }));
          });
        });
        // Het thema onthoudt de laatst gezette kaart (de verborgen 6-pak); zonder deze tik voegt de aangevinkte
        // 2-pak bij het laden alle zes boeken toe.
        info.querySelector('quantity-breaks input[name="quantity"]:checked')?.dispatchEvent(new Event('change', { bubbles: true }));
      } finally {
        galerijen.forEach((g) => { delete g.setActiveMedia; });
      }
    };
    if (window.customElements) customElements.whenDefined('quantity-breaks').then(() => setTimeout(zet, 0));
    else zet();
    // Fotostalen boven de bundels (kleurboek, Kadir 26-10: "de optie variant met pictures swatches"): het thema zet bij
    // een andere staal elk boek in elke bundel op die ene wereld. Dan opnieuw spreiden met de gekozen wereld als #1,
    // zodat de 6-pak alle zes werelden houdt. Alleen met data-kd-stalen op de pagina; het busy book blijft zoals het was.
    if (!info.querySelector('[data-kd-stalen]')) return;
    const gekozen = () => info.querySelector('variant-selects input[type="radio"]:checked')?.value || '';
    let laatst = gekozen();
    let wacht;
    new MutationObserver(() => {
      clearTimeout(wacht);
      wacht = setTimeout(() => {
        const nu = gekozen();
        if (!nu || nu === laatst) return;
        laatst = nu;
        zet(nu);
      }, 60);
    }).observe(info.querySelector('quantity-breaks') || info, { childList: true, subtree: true });
  };

  // Kleur kiezen met een foto in elke bundelkaart (versie B, Zaka 25-10): per boek fotoknoppen in plaats van het
  // keuzemenu van het thema. Het menu blijft verborgen staan; een knop zet het en stuurt het change-event, zodat het
  // thema de variant kent (en de galerij naar die kleur springt). data-kd-fotokeuze = [[kleur, foto-url], ...].
  const fotokeuze = (merk) => {
    if (merk.dataset.kdKlaar) return;
    merk.dataset.kdKlaar = '1';
    let fotos = [];
    try { fotos = JSON.parse(merk.dataset.kdFotokeuze).filter((f) => f[1]); } catch (e) { return; }
    const beeld = Object.fromEntries(fotos);
    const info = merk.closest('product-info') || document;
    info.querySelectorAll('.quantity-break__selector-item').forEach((vak) => {
      const sel = vak.querySelector('select');
      if (!sel || vak.querySelector('.kd-fotokeuze')) return;
      const rij = document.createElement('div');
      rij.className = 'kd-fotokeuze';
      const knoppen = [...sel.options].filter((o) => beeld[o.value]).map((o) => {
        const knop = document.createElement('button');
        knop.type = 'button';
        knop.className = 'kd-fotokeuze__knop';
        knop.dataset.waarde = o.value;
        knop.disabled = o.disabled;
        const img = document.createElement('img');
        Object.assign(img, { src: beeld[o.value], alt: '', width: 60, height: 60, loading: 'lazy' });
        const naam = document.createElement('span');
        naam.textContent = o.value;
        knop.append(img, naam);
        knop.addEventListener('click', (e) => {
          e.preventDefault();
          sel.value = o.value;
          sel.dispatchEvent(new Event('change', { bubbles: true }));
        });
        rij.appendChild(knop);
        return knop;
      });
      if (!knoppen.length) return;
      const markeer = () => knoppen.forEach((k) => k.setAttribute('aria-pressed', String(k.dataset.waarde === sel.value)));
      sel.addEventListener('change', markeer);
      markeer();
      sel.closest('.select')?.classList.add('kd-fotokeuze__menu');
      vak.appendChild(rij);
    });
  };

  // Kleurboek (Kadir 26-10): zes werelden passen niet als fotoknoppen, dus het keuzemenu blijft en krijgt de cover van
  // de gekozen wereld ervoor. Een tik op de cover opent het menu. data-kd-fotomenu = [[wereld, foto-url], ...].
  const fotomenu = (merk) => {
    if (merk.dataset.kdKlaar) return;
    merk.dataset.kdKlaar = '1';
    let beeld = {};
    try { beeld = Object.fromEntries(JSON.parse(merk.dataset.kdFotomenu).filter((f) => f[1])); } catch (e) { return; }
    const info = merk.closest('product-info') || document;
    info.querySelectorAll('.quantity-break__selector-item').forEach((vak) => {
      const sel = vak.querySelector('select');
      if (!sel || vak.querySelector('.kd-fotomenu')) return;
      const img = document.createElement('img');
      Object.assign(img, { className: 'kd-fotomenu', alt: '', width: 40, height: 40 });
      const toon = () => {
        img.hidden = !beeld[sel.value];
        if (beeld[sel.value]) Object.assign(img, { src: beeld[sel.value], alt: sel.value });
      };
      img.addEventListener('click', () => { try { sel.showPicker(); } catch (e) { sel.focus(); } });
      sel.addEventListener('change', toon);
      toon();
      (sel.closest('.select') || sel).before(img);
    });
  };

  // Koopknop "Add to cart - £prijs" (Zaka 26-10: "naam van Atc niet add to basket maar add to cart - PRIJS"). Het thema
  // kan zelf een prijs in de knop zetten, maar die volgt de bundelkeuze niet (bleef £34.97 bij 4 boeken). Daarom hier: de
  // prijs van de aangevinkte bundelkaart, anders de kalenderbundel, anders de prijs onder de titel. kd-head zet
  // window.kdKnopprijs op elke productpagina (busy book sinds Kadir 26-10: "ja, busy book ook").
  const knopprijs = (info) => {
    if (!window.kdKnopprijs || info.dataset.kdKnopprijs) return;
    info.dataset.kdKnopprijs = '1';
    const lees = () => {
      const kaart = info.querySelector('quantity-breaks input[name="quantity"]:checked')?.nextElementSibling;
      const bron = kaart?.querySelector('.quantity-break__price')
        || (info.querySelector('.kd-bundel-input:checked') && info.querySelector('.kd-bundelprijs .price-item--sale'))
        || info.querySelector('.price__sale .price-item--sale');
      const basis = bron ? bron.textContent.trim() : '';
      // aangevinkte extra's onder de bundel tellen mee (Kadir 28-10: "yes, include them"), elk een keer
      const extra = [...info.querySelectorAll('product-info-upsell[data-selected="true"] .upsell__price .regular-price')]
        .map((p) => p.textContent.trim());
      const deel = basis.match(/^(\D*)([\d.,]+)(\D*)$/);
      if (!extra.length || !deel) return basis;
      const komma = /,\d{2}$/.test(deel[2]);
      const getal = (s) => parseFloat((komma ? s.replace(/\./g, '').replace(',', '.') : s.replace(/,/g, '')).replace(/[^\d.]/g, '')) || 0;
      const som = extra.reduce((t, s) => t + getal(s), getal(deel[2]));
      const tekst = som.toFixed(2);
      return deel[1] + (komma ? tekst.replace('.', ',') : tekst) + deel[3];
    };
    const zet = () => {
      const prijs = lees();
      info.querySelectorAll('.main-atc__label__text, .sticky-atc__label__text').forEach((label) => {
        const tekst = prijs && !label.closest('button')?.disabled ? ` - ${prijs}` : '';
        let s = label.nextElementSibling;
        if (!s || !s.classList.contains('kd-knopprijs')) {
          s = document.createElement('span');
          s.className = 'kd-knopprijs';
          label.after(s);
        }
        if (s.textContent !== tekst) s.textContent = tekst;
      });
    };
    let wacht;
    const later = () => { clearTimeout(wacht); wacht = setTimeout(zet, 80); };
    info.addEventListener('change', later);
    info.addEventListener('click', later);
    new MutationObserver(later).observe(info, { childList: true, subtree: true, characterData: true });
    zet();
  };

  // Naam per stuk (schort met naam, 28-10): in elk vak van de bundelkaart (#1, #2) een naamveld onder de ontwerpkeuze.
  // Shrine stuurt een bundel als items[] zonder regeleigenschappen, dus de koopknop (ook die in de plakbalk) gaat hier
  // langs: elk stuk een eigen regel met zijn variant en zijn naam als eigenschap, dan de winkelwagenlade open.
  // Hetzelfde vaknummer houdt dezelfde naam als de klant van kaart wisselt. data-kd-namen = instellingen uit de brief.
  const namen = (merk) => {
    if (merk.dataset.kdKlaar) return;
    merk.dataset.kdKlaar = '1';
    let cfg = {};
    try { cfg = JSON.parse(merk.dataset.kdNamen); } catch (e) { return; }
    const ids = (merk.dataset.kdIds || '').split(',').filter(Boolean);
    const info = merk.closest('product-info') || document;
    const waarden = {};
    const veld = (vak, nr, totaal) => {
      const blok = document.createElement('div');
      blok.className = 'kd-veld kd-naam';
      const id = `kd-naam-${Math.random().toString(36).slice(2, 8)}`;
      // geen <label>: het vak staat al in Shrines kaart, die zelf een label is (een label in een label mag niet)
      const label = document.createElement('span');
      label.className = 'form__label';
      label.id = `${id}-label`;
      label.textContent = totaal > 1 ? cfg.label_n.replace('{n}', nr) : cfg.label;
      const invoer = document.createElement('input');
      Object.assign(invoer, { id, type: 'text', className: 'kd-veld__invoer', placeholder: cfg.voorbeeld || '',
        maxLength: cfg.max || 20, autocomplete: 'off', value: waarden[nr] || '' });
      invoer.dataset.kdVak = nr;
      invoer.setAttribute('aria-labelledby', label.id);
      invoer.setAttribute('aria-required', 'true');
      invoer.setAttribute('autocapitalize', 'words');
      const fout = document.createElement('p');
      fout.className = 'kd-veld__fout';
      fout.setAttribute('role', 'alert');
      fout.hidden = true;
      fout.textContent = cfg.fout;
      // een klik in het veld mag de kaart (een label) niet omzetten of het vak openen en sluiten
      ['click', 'mousedown'].forEach((t) => invoer.addEventListener(t, (e) => e.stopPropagation()));
      invoer.addEventListener('input', () => {
        waarden[nr] = invoer.value;
        info.querySelectorAll(`.kd-naam input[data-kd-vak="${nr}"]`).forEach((ander) => {
          if (ander !== invoer) ander.value = invoer.value;
        });
        if (invoer.value.trim()) { blok.classList.remove('kd-veld--fout'); fout.hidden = true; }
      });
      blok.append(label, invoer, fout);
      vak.appendChild(blok);
    };
    const zet = () => {
      info.querySelectorAll('quantity-breaks label[for^="quantity"]').forEach((kaart) => {
        const vakken = [...kaart.querySelectorAll('.quantity-break__selector-item')];
        vakken.forEach((vak, i) => { if (!vak.querySelector('.kd-naam')) veld(vak, i + 1, vakken.length); });
      });
    };
    const gekozen = () => info.querySelector('quantity-breaks input[name="quantity"]:checked');
    const stuur = async (form, e) => {
      if (!(form instanceof HTMLFormElement) || !form.matches('form[action*="/cart/add"]') || form.closest('cart-drawer')) return;
      if (!ids.includes(String(form.querySelector('[name="id"]')?.value))) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      const radio = gekozen();
      const kaart = radio && info.querySelector(`label[for="${radio.id}"]`);
      const vakken = kaart ? [...kaart.querySelectorAll('.quantity-break__selector-item')] : [];
      const invoer = vakken.map((vak) => vak.querySelector('.kd-naam input'));
      const leeg = invoer.filter((v) => !v || !v.value.trim());
      if (!vakken.length || leeg.length) {
        leeg.filter(Boolean).forEach((v) => {
          v.closest('.kd-veld').classList.add('kd-veld--fout');
          v.closest('.kd-veld').querySelector('.kd-veld__fout').hidden = false;
        });
        const eerste = leeg.find(Boolean) || kaart;
        eerste?.scrollIntoView({ block: 'center', behavior: 'smooth' });
        if (eerste?.focus) eerste.focus({ preventScroll: true });
        return;
      }
      const items = vakken.map((vak, i) => ({
        id: Number(vak.dataset.selectedId || form.querySelector('[name="id"]').value),
        quantity: 1,
        properties: { [cfg.eigenschap]: invoer[i].value.trim() },
      }));
      const knoppen = [...form.querySelectorAll('[type="submit"]'),
        // form.id is hier het verborgen veld name="id" (variant), niet het id-attribuut
        ...(form.getAttribute('id') ? document.querySelectorAll(`button[form="${CSS.escape(form.getAttribute('id'))}"]`) : [])];
      knoppen.forEach((k) => { k.setAttribute('aria-disabled', 'true'); k.classList.add('loading'); });
      const lade = document.querySelector('cart-drawer');
      const root = window.Shopify?.routes?.root || '/';
      try {
        const r = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items,
            sections: lade ? lade.getSectionsToRender().map((s) => s.id) : [],
            sections_url: window.location.pathname,
          }),
        });
        const antwoord = await r.json();
        if (!r.ok) throw new Error(antwoord.description || antwoord.message);
        if (lade) { lade.classList.remove('is-empty'); lade.renderContents(antwoord); } else window.location.href = `${root}cart`;
      } catch (fout) {
        console.error('KIDDUC namen', fout);
      } finally {
        knoppen.forEach((k) => { k.removeAttribute('aria-disabled'); k.classList.remove('loading'); });
      }
    };
    document.addEventListener('submit', (e) => stuur(e.target, e), true);
    // de knop in de plakbalk staat buiten het formulier (form=...): die vangen we bij de klik
    document.addEventListener('click', (e) => {
      const knop = e.target.closest && e.target.closest('button');
      if (knop && knop.form && (knop.type === 'submit' || knop.hasAttribute('form'))) stuur(knop.form, e);
    }, true);
    let wacht;
    const later = () => { clearTimeout(wacht); wacht = setTimeout(zet, 60); };
    if (window.customElements) customElements.whenDefined('quantity-breaks').then(() => setTimeout(zet, 0));
    else zet();
    new MutationObserver(later).observe(info.querySelector('quantity-breaks') || info, { childList: true, subtree: true });
  };

  // ----- Overgenomen van Winter & Wonder (snowfall.js, 28-10) voor de fotopop en de haaktas op KIDDUC -----
  // Personalisatie (naam, nummer, gravure, foto): het productformulier heeft novalidate, dus een lege verplichte
  // invoer hier tegenhouden voor Shrine het naar de winkelwagen stuurt. Capture op document = voor Shrines eigen
  // handlers. Ook de klik: de zwevende knop (type=button, form=...) roept Shrine rechtstreeks aan zonder submit (24-10).
  const leeg = (veld) => (veld.type === 'file' ? !veld.files.length : !veld.value.trim());
  const tegenhouden = (form, e) => {
    if (!(form instanceof HTMLFormElement) || !form.matches('form[action*="/cart/add"]')) return;
    const fout = [...form.elements].filter((v) => v.required && !v.disabled && v.closest('.kd-veld') && leeg(v));
    if (!fout.length) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    fout.forEach((v) => {
      const vak = v.closest('.kd-veld');
      vak.classList.add('kd-veld--fout');
      const m = vak.querySelector('.kd-veld__fout');
      if (m) m.hidden = false;
    });
    fout[0].closest('.kd-veld').scrollIntoView({ block: 'center', behavior: 'smooth' });
    fout[0].focus({ preventScroll: true });
  };
  document.addEventListener('submit', (e) => tegenhouden(e.target, e), true);
  document.addEventListener('click', (e) => {
    const knop = e.target.closest && e.target.closest('button');
    if (knop && knop.form && (knop.type === 'submit' || knop.hasAttribute('form'))) tegenhouden(knop.form, e);
  }, true);
  const herstel = (e) => {
    const vak = e.target.closest && e.target.closest('.kd-veld--fout');
    if (!vak || leeg(e.target)) return;
    vak.classList.remove('kd-veld--fout');
    const m = vak.querySelector('.kd-veld__fout');
    if (m) m.hidden = true;
  };
  document.addEventListener('input', herstel);
  document.addEventListener('change', herstel);

  // Personalisatie per stuk in een bundel (tas en pop, 28-10). Shrine stuurt een bundelkaart als items[0], items[1];
  // de velden van stuk i (data-kd-stuk) hebben geen name maar data-kd-naam en gaan hier als items[i][properties][naam]
  // mee, ook een foto (FormData). Zo krijgt elke tas of pop een eigen regel met de eigen naam of foto.
  const eigenFetch = window.fetch;
  window.fetch = function (url, opties) {
    const body = opties && opties.body;
    if (body instanceof FormData && String(url).includes('/cart/add')) {
      const merk = [...document.querySelectorAll('[data-kd-stukken]')]
        .find((m) => m.dataset.kdStukken === body.get('section-id'));
      if (merk) {
        // een gewoon formulier zonder bundelkaart (id + quantity): omzetten naar items[], een regel per stuk
        if (!body.has('items[0][id]') && body.has('id')) {
          const id = body.get('id');
          const n = Math.max(1, Number(body.get('quantity') || 1));
          body.delete('id');
          body.delete('quantity');
          for (let i = 0; i < n; i += 1) {
            body.append(`items[${i}][id]`, id);
            body.append(`items[${i}][quantity]`, '1');
          }
        }
        // Shrine voegt twee gelijke stuks samen tot een item (pop 30-10: 2 x 8 in = items[0] met quantity 2); dan heeft
        // stuk 2 geen items[1] en vallen zijn foto of namen weg (zo ook ornament, beer, trui en loper). Hier weer een
        // item per stuk. Bundels met maten hebben nu hooguit 2 stuks, dus de volgorde klopt altijd.
        const rijen = [];
        for (let i = 0; body.has(`items[${i}][id]`); i += 1) {
          const velden = [...body.entries()].filter(([k]) => k.startsWith(`items[${i}][`));
          const n = Math.max(1, Number(body.get(`items[${i}][quantity]`) || 1));
          for (let k = 0; k < n; k += 1) rijen.push(velden);
        }
        if (rijen.some((_, j) => !body.has(`items[${j}][id]`))) {
          [...body.keys()].filter((k) => k.startsWith('items[')).forEach((k) => body.delete(k));
          rijen.forEach((velden, j) => velden.forEach(([k, w]) => {
            const sleutel = k.replace(/^items\[\d+\]/, `items[${j}]`);
            body.append(sleutel, sleutel.endsWith('[quantity]') ? '1' : w);
          }));
        }
        merk.querySelectorAll('[data-kd-stuk]').forEach((stuk) => {
          const i = stuk.dataset.kdStuk;
          if (!body.has(`items[${i}][id]`)) return;
          stuk.querySelectorAll('[data-kd-naam]').forEach((v) => {
            const waarde = v.type === 'file' ? v.files[0] : v.value.trim();
            if (waarde) body.append(`items[${i}][properties][${v.dataset.kdNaam}]`, waarde);
          });
        });
      }
    }
    return eigenFetch.apply(this, arguments);
  };

  // Alleen de groepen van de aangevinkte bundelkaart tonen: 1 tas = groep 1, 2 tassen = groep 1 en 2. Verborgen
  // groepen staan uit (disabled), zodat tegenhouden() er niet over struikelt.
  const stukken = (merk) => {
    if (merk.dataset.kdKlaar) return;
    merk.dataset.kdKlaar = '1';
    const info = merk.closest('product-info') || document;
    const toon = () => {
      const n = Number(info.querySelector('quantity-breaks input[name="quantity"]:checked')?.value || 1);
      merk.querySelectorAll('[data-kd-stuk]').forEach((stuk) => {
        const aan = Number(stuk.dataset.kdStuk) < n;
        stuk.hidden = !aan;
        stuk.querySelectorAll('input, select, textarea').forEach((v) => { v.disabled = !aan; });
      });
      merk.classList.toggle('kd-stukken--meer', n > 1);
    };
    info.addEventListener('change', (e) => { if (e.target.name === 'quantity') toon(); });
    toon();
  };

  // Bundel met maten van verschillende prijs (pop, 28-10): Shrine rekent de kaartprijs als aantal x de prijs van een
  // maat, ook als #2 een grotere maat is. Hier de echte som van de gekozen maten (zo rekent de winkelwagen ook) en de
  // prijs per stuk als gemiddelde; knopprijs neemt het bedrag van de kaart over. Gelijke prijzen (tas): niets te doen.
  const somprijs = (merk) => {
    if (merk.dataset.kdKlaar) return;
    merk.dataset.kdKlaar = '1';
    let prijzen = {};
    try { prijzen = JSON.parse(merk.dataset.kdSomprijs); } catch (e) { return; }
    if (new Set(Object.values(prijzen)).size < 2) return;
    const info = merk.closest('product-info') || document;
    const munt = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP';
    const geld = (c) => new Intl.NumberFormat('en-GB', { style: 'currency', currency: munt }).format(c / 100);
    // review 29-10: ook de van-prijs per maat optellen, de maatprijs in elk keuzemenu, en de prijs onder de titel (en in
    // de plakbalk) volgt de gekozen kaart (regel 18); bij 12 in bleef die op £34.97 tegen £69.97
    const lees = (naam) => { try { return JSON.parse(merk.dataset[naam] || '{}'); } catch (e) { return {}; } };
    const van = lees('kdSomvan');
    const maat = lees('kdMaat');
    // Zaka en Kadir 29-10 ("1 ornament £29.97" naast The Pair £29.97 was onduidelijk): een kaart die niet gekozen is,
    // toont de maten van de gekozen kaart (1 groot naast 2 groot, niet 2 klein); vak 2 volgt vak 2, anders vak 1. Wie
    // die kaart kiest, krijgt die maten ook echt in zijn menu's, zodat de prijs niet verspringt. Alleen de gekozen kaart
    // krijgt change: een menu van een niet-gekozen kaart aanraken zet het thema op die kaart (The Pair ging dan als 1 stuk
    // de wagen in). Formulierherstel na herladen staat uit (autocomplete="off" in snippets/quantity-breaks.liquid).
    const goedkoopId = Object.keys(prijzen).sort((a, b) => prijzen[a] - prijzen[b])[0];
    const isGekozen = (kaart) => !!document.getElementById(kaart.getAttribute('for') || '')?.checked;
    const vakkenVan = (kaart) => [...kaart.querySelectorAll('.quantity-break__selector-item')];
    const menus = (vak) => [...vak.querySelectorAll('select.quantity-break__variant-select')];
    let vorigeKaart = [...info.querySelectorAll('.quantity-break')].find(isGekozen) || null;
    const volg = (e) => {
      if (e.target.name !== 'quantity') return;
      const kaart = [...info.querySelectorAll('.quantity-break')].find(isGekozen);
      const bron = vorigeKaart;
      vorigeKaart = kaart || vorigeKaart;
      if (!kaart || !bron || bron === kaart) return;
      const bronVakken = vakkenVan(bron);
      vakkenVan(kaart).forEach((vak, i) => {
        const bronMenus = menus(bronVakken[i] || bronVakken[0]);
        menus(vak).forEach((sel, j) => {
          const w = bronMenus[j]?.value;
          if (w == null || sel.value === w || ![...sel.options].some((o) => o.value === w)) return;
          sel.value = w;
          sel.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    };
    const tekst = (el, t) => { if (el && el.textContent.trim() !== t) el.textContent = t; };
    const titel = (blok, som, somVan) => {
      if (!blok) return;
      blok.querySelectorAll('.price__regular .price-item--regular, .price__sale .price-item--sale').forEach((el) => tekst(el, geld(som)));
      blok.querySelectorAll('.price__compare-price .price-item--regular, s.price-item--regular').forEach((el) => tekst(el, geld(somVan)));
      const korting = `${Math.round((1 - som / somVan) * 100)}%`;
      blok.querySelectorAll('.price__badge-custom, .price__badge-sale').forEach((el) => {
        const t = el.textContent.trim().replace(/\d+%/, korting);
        if (somVan > som) tekst(el, t);
      });
    };
    const zet = () => {
      let gekozen = null;
      const keuze = [...info.querySelectorAll('.quantity-break')].find(isGekozen);
      const keuzeIds = keuze ? vakkenVan(keuze).map((v) => v.dataset.selectedId).filter((id) => prijzen[id]) : [];
      info.querySelectorAll('.quantity-break').forEach((kaart) => {
        const vakken = vakkenVan(kaart);
        if (!vakken.length || vakken.some((v) => !prijzen[v.dataset.selectedId])) return;
        const deze = kaart === keuze;
        const ids = vakken.map((v, i) => (deze ? v.dataset.selectedId : keuzeIds[i] || keuzeIds[0] || goedkoopId));
        // de bundelkorting van de kaart (29-10, ornament/loper/mat: 2 stuks min 9.97 of 14.97) gaat er ook af
        const som = Math.round(ids.reduce((t, id) => t + prijzen[id], 0) *
          (parseFloat(kaart.dataset.percentageLeft) || 1)) - Math.round(parseFloat(kaart.dataset.fixedDiscount) || 0);
        const somVan = ids.reduce((t, id) => t + (van[id] || prijzen[id]), 0);
        tekst(kaart.querySelector('.quantity-break__price'), geld(som));
        if (somVan > som) tekst(kaart.querySelector('.quantity-break__compare-price'), geld(somVan));
        const elk = kaart.querySelector('.quantity-break__caption span');
        const gemiddeld = geld(Math.round(som / vakken.length));
        if (elk && vakken.length > 1 && elk.textContent.trim() !== gemiddeld) elk.textContent = gemiddeld;
        // maatprijs in het menu = de prijs per stuk in deze kaart (Kadir 29-10: staat erboven "£14.99 per ornament",
        // dan ook £14.99 in het menu en niet de volle £19.97), zelfde afronding als de prijs per stuk
        const stukprijs = (p) => Math.round(p * (parseFloat(kaart.dataset.percentageLeft) || 1) -
          (parseFloat(kaart.dataset.fixedDiscount) || 0) / vakken.length);
        kaart.querySelectorAll('select.quantity-break__variant-select option').forEach((o) => {
          if (maat[o.value] != null) tekst(o, `${o.value} · ${geld(stukprijs(maat[o.value]))}`);
        });
        if (deze) gekozen = [som, somVan];
      });
      if (gekozen) {
        titel(info.querySelector('[id^="price-"]'), ...gekozen);
        titel(document.querySelector('.sticky-atc'), ...gekozen);
      }
    };
    let wacht;
    const later = () => { clearTimeout(wacht); wacht = setTimeout(zet, 120); };
    info.addEventListener('change', volg);
    info.addEventListener('change', later);
    // terug via de bfcache: de pagina komt terug zoals hij was, de prijzen opnieuw zetten
    window.addEventListener('pageshow', (e) => { if (e.persisted) later(); });
    // ook het prijsblok kijken: het thema zet daar na een maatwissel zijn eigen bedrag terug
    [info.querySelector('quantity-breaks') || info, info.querySelector('[id^="price-"]')?.parentElement, document.querySelector('.sticky-atc')]
      .filter(Boolean).forEach((el) => new MutationObserver(later).observe(el, { childList: true, subtree: true, characterData: true }));
    later();
  };

  const init = (root = document) => {
    root.querySelectorAll('[data-kd-bundel]').forEach(bundel);
    root.querySelectorAll('[data-kd-namen]').forEach(namen);
    root.querySelectorAll('[data-kd-stukken]').forEach(stukken);
    root.querySelectorAll('[data-kd-somprijs]').forEach(somprijs);
    root.querySelectorAll('[data-kd-spreid]').forEach(spreid);
    root.querySelectorAll('[data-kd-fotokeuze]').forEach(fotokeuze);
    root.querySelectorAll('[data-kd-fotomenu]').forEach(fotomenu);
    root.querySelectorAll('product-info').forEach(knopprijs);
    root.querySelectorAll('.kd video, .product__media-wrapper video').forEach(gif);
    root.querySelectorAll('.kd-reels video').forEach(reel);
    root.querySelectorAll('[data-kd-fotolabels]').forEach(fotolabels);
    root.querySelectorAll('[data-kd-magie]').forEach(magie);
    root.querySelectorAll('[data-kd-aftel]').forEach(aftel);
    root.querySelectorAll('[data-kd-saleklok]').forEach(saleklok);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  // Thema-editor: sectie opnieuw geladen.
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
